  <div class="footer-viiv-logo d-flex align-items-center">
  <div [ngStyle]="{ 'display' : screenWidth <= 480 ? 'none': 'block' }" >
    <a href="https://ivericbio.com/" target="_blank">
      <img
        class="iveric-logo"
        src="../../../assets/images/Astellas Logo.png"
        alt=""
    /></a>
  </div>
  <div class="safetyDiv d-flex-column" 
  [ngStyle]="{ 'display' : screenWidth <= 480 ? 'none': 'block' }" >
    <div class="parent">
      <div class="quick-links">
        <div class="links">
          <div class="text-links">
            <a href="https://ivericbio.com/privacy-policy/" target="_blank"
              >Privacy Policy</a
            >&nbsp;|
            <a
              href="https://ivericbio.com/terms-of-use/"
              target="_blank"
            >
              Terms of Use </a
            >&nbsp;|
            <a href="https://ivericbio.com/contact-us/" target="_blank">
              Contact Us</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-info">
      <span>
        <p class="mb-0">
          This site is intended only for residents of the United States and U.S. healthcare professionals only.
        </p>
        <p>
          Trademarks are the property of their respective owners.
        </p>
        <span class="powered-by-LLC">Portal powered by &copy; 2023 PharmaCord LLC.</span>
        <span class="d-flex justify-content-between">
          <p>Copyright &copy; 2024 Astellas Pharma Inc. or its affiliates. All trademarks are the property of their respective owners.
          </p>
          <p>US-AP-2300091 03/24</p>
        </span>
      </span>
    </div>
  </div>
  
  <!-- Right now not required this icon -->
  <div class="footer-icon d-flex position--sticky" *ngIf="showChatIcon">
    <div class="webchat-main-frame" *ngIf="iframeVisible" [ngStyle]="maximizeWebChat && {'height': '5rem'}" >
      <div class="webchat-header">
        <span class="webchat-header-text">IZERVAY My Way Chat</span>
        <div class="webchat-header-icons-div">
          <img  class="webchat-header-icons"  src="../../../assets/images/minimize-icon.svg" alt="minimize"  
          (click)="togglemaximizeWebChat()"
          *ngIf="!maximizeWebChat">
          <img class="webchat-header-icons"  src="../../../assets/images/maximize-icon.png" alt="maximize" 
          (click)="togglemaximizeWebChat()"
          *ngIf="maximizeWebChat">
          <img class="webchat-header-icons" src="../../../assets/images/close-icon.png"
            alt="exit cross" (click)="toggleIframe()" >
        </div>
      </div>
      <iframe [src]="chatUrl | safe:'resourceUrl'" 
        class="webchat-iframe"
        id="webchatId"
        [ngStyle]="maximizeWebChat && {'display': 'none'}"
        *ngIf="iframeVisible">
      </iframe>
    </div>
    <div class="footer-frame" *ngIf="!iframeVisible" >
      <img class="viiv-logo" (click)="toggleIframe()" src="/assets/images/footer-icon.svg" alt=""/>
    </div>
    <!-- <div class="footer-info">
      <p> Our ccess Coordinators are here to assist you with your questions and -needs.</p>
      <p>Call - <a class="call" href="tel:18445383288">1-844-588-3288</a> (toll free), Monday-Friday, 8AM-11PM (ET)</p>
      <p>Multilingual options are available.</p>
    </div> -->
  </div>
</div>

<div  [ngStyle]="{ 'display' : screenWidth <= 480 ? 'block': 'none' }" >
  <div  class="logo-and-quick-links">
    <div>
      <a href="https://ivericbio.com/" target="_blank">
        <img
          class="iveric-logo"
          src="../../../assets/images/Astellas Logo.png"
          alt=""
      /></a>
    </div>
    <div class="parent">
      <div class="quick-links">
        <div class="links">
          <div class="text-links">
            <div class="text-links-upper">
              <a href="https://ivericbio.com/privacy-policy/" target="_blank"
                >Privacy Policy</a
              >&nbsp;|
              <a
                href="https://ivericbio.com/terms-of-use/"
                target="_blank"
              >
                Terms of Use </a
              >&nbsp;| 
           </div>
           <div class="text-links-lower">
              <a href="https://ivericbio.com/contact-us/" target="_blank">
                Contact Us</a>
          </div>
          </div>
        </div>
      </div>
    </div>

  </div>
    <div>
      <div class="copyright-info-mobile">
        <span>
          <p class="mb-0">
            Trademarks are property of their respective owners.
          </p>
          <!-- <p>
            This website is funded and developed by ViiV Healthcare. Access to
            this site is restricted to authorized U.S. Healthcare Professionals,
            Staff, and Patient Representatives only.
          </p> -->
          <span class="powered-by-LLC">Portal powered by &copy; 2023 PharmaCord LLC.</span>
          <span class="lower-content">
            <p>&copy; 2023 IVERIC bio, INC. All rights reserved.</p>
            <p>US-AP-2300091 11/23</p>
          </span>
        </span>
      </div>
   </div>
</div>